import React from "react";

const USER_GUIDES = [
  { file: "UserGuide_DE.pdf", label: "Deutsch (DE)" },
  { file: "UserGuide_EN.pdf", label: "English (EN)" },
  { file: "UserGuide_ES.pdf", label: "Español (ES)" },
  { file: "UserGuide_FR.pdf", label: "Français (FR)" },
  { file: "UserGuide_IT.pdf", label: "Italiano (IT)" },
  { file: "UserGuide_PL.pdf", label: "Polski (PL)" },
  { file: "UserGuide_PT.pdf", label: "Português (PT)" },
  { file: "UserGuide_SV.pdf", label: "Svenska (SV)" },
];

export default function UserGuide() {
  return (
    <div className="app-container">
      <div className="background-pattern"></div>

      <div className="main-content compliance-main">
        <div className="legal-header">
          <img src="/logo.png" alt="Auto Shiny Counter Logo" className="app-logo" />
          <h1 className="title">User Guides</h1>
          <p className="legal-date">
            Download the Auto Shiny Counter Dongle setup guide as PDF in your language.
          </p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>PDF Downloads</h2>
            <ul className="compliance-doc-list">
              {USER_GUIDES.map(({ file, label }) => (
                <li key={file}>
                  <a href={`/${file}`} download className="compliance-doc-link">
                    {label}
                  </a>
                  <span className="compliance-doc-filename"> - {file}</span>
                </li>
              ))}
            </ul>
          </section>

          <section className="legal-section">
            <p>
              We are continuously expanding our multilingual user guides based on where
              our community grows. As we receive orders from new countries, we add
              localized instructions to make setup as smooth as possible for everyone.
            </p>
            <p>
              If your language is not available yet, feel free to reach out - your
              feedback directly helps us prioritize what to add next.
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <a href="/" className="back-link">
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
}
